import { render, staticRenderFns } from "./HrDashboardTable.vue?vue&type=template&id=0081309b&scoped=true"
import script from "./HrDashboardTable.vue?vue&type=script&lang=js"
export * from "./HrDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./HrDashboardTable.vue?vue&type=style&index=0&id=0081309b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081309b",
  null
  
)

export default component.exports